import { Component } from 'react';

export class TickCircleSVG extends Component<{ className?: string }> {
    render() {
        const { className } = this.props;

        return (
            <svg
                className={className}
                data-testid="tick-circle-svg"
                width="19"
                height="19"
                viewBox="0 0 25 25"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12.5 25C19.404 25 25 19.404 25 12.5S19.404 0 12.5 0 0 5.596 0 12.5 5.596 25 12.5 25z"
                    fill="#0D9876"
                />
                <path
                    d="M19.159 9.38a.812.812 0 0 0-.234-.569l-1.139-1.138a.812.812 0 0 0-1.138 0l-5.491 5.5-2.461-2.47a.812.812 0 0 0-1.139 0L6.42 11.842a.812.812 0 0 0 0 1.138l3.03 3.03 1.139 1.138a.812.812 0 0 0 1.138 0l1.138-1.138 6.06-6.06c.151-.15.235-.36.235-.57z"
                    fill="#fff"
                />
            </svg>
        );
    }
}
